const sanitizePath = (path) => path.replace(/\/developers\/(pt|es|en)/g, '');

module.exports = { sanitizePath };
